import React from 'react';
import { Attachments, HasAccess } from 'components/index';
import { useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

export const TaskAttachments = React.memo((props: { isFinalStatus?: boolean }) => {
  const { isFinalStatus } = props;
  const { taskId } = useParams() as { taskId: string };
  const { hasAccess } = useAccessControl();
  return (
    <HasAccess role={PERMISSIONS.tasks.attachment.read}>
      <Attachments
        entityId={taskId}
        service={'wrd'}
        entityName={'TASK'}
        hasAccessToWrite={hasAccess(PERMISSIONS.tasks.attachment.write) && !isFinalStatus}
        hasAccessToDelete={hasAccess(PERMISSIONS.tasks.attachment.delete) && !isFinalStatus}
      />
    </HasAccess>
  );
});
